import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from "moment";
import { GlobalsService } from './globals';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private globals: GlobalsService) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = (this.globals.user) ? this.globals.user.token : undefined;
        if (token !== undefined && token !== null && token !== '') {
            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + token,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Timezone':  moment().zone().toString()
                },
            });
            return next.handle(request);
        } else {
            return next.handle(request);
        }
    }
}
